import React,{Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./Resources/bootstrap/dist/new_css/bootstrap.css";
import './i18n'
import swDev from './swDev'
import secureLocalStorage from 'react-secure-storage';
import loadingTranslation from "../src/loadingTranslation.json"
import { formStateStore } from './Redux/Store/store';
import { updateContainerInfo } from './Redux';
import { reset, updateStateInRedux, updateStore } from './Redux/Actions/FormStateActions';
import axios from 'axios';

import { loadConfig } from './url';//Please don't remove this line
const App= React.lazy(()=> import("./App"));

function generateBuildNumber(){

  axios.get(`${window.location.origin}${process.env.REACT_APP_PUBLIC_URL}/GetBuildVersion`).then((res) =>{
    console.log("generateBuildNumber",res.data);
    window.buildNumber_iforms_fb= res?.data?.toString()?.split(".")[1];
  }
  )
  console.log("generateBuildNumber",window.buildNumber_iforms_fb);

  return window.buildNumber_iforms_fb || Math.floor(Math.random() * 10000);
}
function getBuildNo(){
  if(window.buildNumber_iforms_fb){
    return window.buildNumber_iforms_fb
  }
  else{
    const build= generateBuildNumber();
  console.log("generateBuildNumber",build);

    return build || Math.floor(Math.random() * 10000);
  } 
}
window.getBuildNo = () => {
  return getBuildNo()
}

function getJsfileContext()
{

  var relative_context;
  var relative_context_bool;

  if( window.loadIformClientFromBackendContext && window?.WDeskData?.Processname ){

    relative_context_bool = window.loadIformClientFromBackendContext(window?.WDeskData?.Processname);

    if(relative_context_bool){

      const windowKey = `iform_backend_context_${window?.WDeskData?.Processname}`
      // window[windowKey] = props.backend_app_context;

      relative_context = `${window[windowKey]}/js`;
    }
    else{
      relative_context = process.env.REACT_APP_PUBLIC_URL;
    }
  }
  else{
    relative_context = process.env.REACT_APP_PUBLIC_URL;
  }
  return relative_context;
}

function loadFonts(){
  console.log("loadfonts");

  if(window?.getExternalFonts){
    const externalFonts= window.getExternalFonts();

    externalFonts?.map((fontName)=>{
        console.log("loadfonts", fontName);
      try{

        let url = `url(${getJsfileContext()}/fonts/${encodeURIComponent(fontName)}.ttf)`;
        const myFont = new FontFace(`${fontName}`, url );
        myFont.load();
        document.fonts.add(myFont);
        console.log("loadfonts", fontName, myFont);
      }
      catch{
        console.log("error due to fonts: ", fontName );
      }

        // font-family: 'Playfair Display';
        // src: url(./fonts/Playfair_Display/PlayfairDisplay-Italic.ttf);
        // font-style: italic;
        // font-weight: 100;
      })
    }
  }

function loadScripts(filePaths, relative_context) {
  return Promise.all(filePaths.map((filePath, fileIndex) => {
    return new Promise((resolve, reject) => {
      const path = `${relative_context}${filePath}?version=${window.buildNumber_iforms_fb}`;
      
      if (path) {
        const script = document.createElement('script');
        script.setAttribute('src', path);
        script.setAttribute('id', `iformClient_js_LSMSAppPortal${fileIndex}`);
        
        script.onload = () => {
          console.log(`✅ Loaded script: ${path}`);
          resolve();
        };

        script.onerror = () => {
          console.error(`❌ Failed to load script: ${path}`);
          reject();
        };

        document.body.appendChild(script);
      }
    });
  }));
}

async function getExternalFilesPaths(){
  if(window?.getExternalJSPaths){
    var relative_context = getJsfileContext();
    var filePaths= window?.getExternalJSPaths();
    if (filePaths && filePaths.length > 0) {
      try {
        // Step 1: Load the first set of scripts
        await loadScripts(filePaths, relative_context);

        console.log("✅ All scripts (including dynamically added ones) are loaded.");
        formStateStore.dispatch(updateStateInRedux({ name: "iformClientLoaded", value: true }));
        loadFonts();
        if(window?.WDeskData?.Processname)
          window[window.WDeskData.Processname] = true;

      } catch (error) {
        console.error("❌ Some scripts failed to load:", error);
        formStateStore.dispatch(updateStateInRedux({ name: "iformClientLoaded", value: false }));
      }
    }
    else{
      formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      loadFonts();
      if(window?.WDeskData?.Processname)
        window[window.WDeskData.Processname] = true;
    }
  }
}

const metaTag = document.querySelector('meta[id="mui-meta"]');
    
if (metaTag) {
  const value = metaTag.getAttribute('content');
  formStateStore.dispatch(updateStore({ name: "noncevalue", value: value, key: "default"}))
}

const cspResponse =()=>{
let uniqueNumber;
const equiv = 'Content-Security-Policy';
// if (!from_micro_frontend) {
  var xhttp = new XMLHttpRequest();

  xhttp.open("POST", '/oap-rest/app/init_app', false);
  xhttp.setRequestHeader('Content-Type', 'application/json');
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      let headers = xhttp.getResponseHeader('Content-Security-Policy');
      if (headers) {
        const regex = /'nonce-([^']+)'/;
        const match = regex.exec(headers);
        if (match) {
          uniqueNumber = match[1];
          formStateStore.dispatch(updateStore({ name: "noncevalue", value: uniqueNumber, key: "default"}))
          document
            .querySelector('#unique-number')
            .setAttribute('content', headers);
          document.querySelector('#unique-number').setAttribute('http-equiv', 'Content-Security-Policy');
          document.querySelector('#mui-meta').setAttribute('content', uniqueNumber);
          // document.querySelector('#google-api').setAttribute('nonce', uniqueNumber);
          // document.querySelector('#google-gsi').setAttribute('nonce', uniqueNumber);
        }
      }
    }
  };
  xhttp.send();
}

window.setContainerId = (containerId) => {
    if(containerId==="ngform") {
      window.istaskOpen= true;
    }
    else{
      window.istaskOpen= false;
    }
    formStateStore.dispatch(updateContainerInfo({ key: containerId }))
  }

function loadIformClient(){
  const buildnum = generateBuildNumber();
  console.log(buildnum);
  if(!window.location.pathname.includes("afb_subform")){
    var relative_context = getJsfileContext();
    const isIformClientLoaded = document.querySelector(`script[src*="${relative_context}/iformclient.js"]`);
    console.log("inside loadIformClient:", isIformClientLoaded, window.location.pathname)
    if(isIformClientLoaded===null){
      const iformClient_url= `${relative_context}/iformclient.js?version=${getBuildNo()}`;
      var script = document.createElement('script');
      script.setAttribute('src', iformClient_url);
      script.setAttribute('id', "iformClient_js_LSMSAppPortal");
      script.onload= () =>{ 
        getExternalFilesPaths();
        var filePaths= window?.getExternalJSPaths();
        console.log("inside loadIformClient filepath:", filePaths, window?.location?.pathname)
        if(!window?.getExternalJSPaths()?.length){
          formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
          loadFonts();
          if(window?.WDeskData?.Processname)
            window[window.WDeskData.Processname] = true;
        }
      }
      document.body.appendChild(script);
    } 
  }
}

const localeKey=secureLocalStorage.getItem("locale");
    if(localeKey){
      localStorage.setItem("locale",localeKey);
      if(window?.LSMSAppPortal_configs?.selectedLanguage)
        window.LSMSAppPortal_configs.selectedLanguage= localeKey || navigator.language || navigator.userLanguage;
    }
      
const translationStyles1=window?.LSMSAppPortal_configs?.selectedLanguage;
  // if(process.env.REACT_APP_PUBLIC_URL === "/LSMSAppPortal"){
    console.log("loadIformClient")
    loadIformClient();
  // }



function loadIdesignfrm(){
  var relative_context = getJsfileContext();
  const idesignfrmLoaded = document.querySelector(`script[src="${relative_context}/idesignfrm.js"]`);
  if(idesignfrmLoaded===null){
    const idesignfrm_url= `${relative_context}/idesignfrm.js`;
    var script = document.createElement('script');
    script.setAttribute('src', idesignfrm_url);
    script.setAttribute('id', "idesignfrm_js_LSMSAppPortal");
    document.body.appendChild(script);
  }
}
  loadIdesignfrm();

function loadInterfaceUtil(){
  var relative_context = getJsfileContext();
  const isInterfaceUtilLoaded = document.querySelector(`script[src="${relative_context}/interfaceutil.js"]`);
  if(isInterfaceUtilLoaded===null){
    const interfaceUtil_url= `${relative_context}/interfaceutil.js`;
    var script = document.createElement('script');
    script.setAttribute('src', interfaceUtil_url);
    script.setAttribute('id', "interfaceutil_js_LSMSAppPortal");
    document.body.appendChild(script);
  }
}
if(process.env.REACT_APP_PUBLIC_URL === "/LSMSAppPortal"){
  loadInterfaceUtil()
}

//getExternalFilesPaths();

// ***********************************  MicroFrontend component implementation for MDM Module **************************************
window.renderPreview = async (containerId, props) => {
  const buildnum = generateBuildNumber();
  console.log(buildnum);
  
    if(props.ContainerId==="ngform"){
      window.istaskOpen= true;
    }
    else{
      window.istaskOpen= false;
    }
    window.formLoaderRan = false;
    window.langChange = false; // when lang is present in QueryParam
    if(document.getElementById(containerId)) {
      formStateStore.dispatch(reset({key: containerId,formState: {}, resetContainerId: containerId}));
      formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
      formStateStore.dispatch(updateContainerInfo({ key: props.passedData?.formMataData_json?.ContainerId }))
      var relative_context = getJsfileContext();
      const isIformClientLoaded = document.querySelector(`script[src*="${relative_context}/iformclient.js"]`);
      if((isIformClientLoaded && window.loadIformClientFromBackendContext && window.loadIformClientFromBackendContext(window?.WDeskData?.Processname)) || window.changeFormLocaleFunctionCalling) {
        formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      }
      else if(window[window?.WDeskData?.Processname]) {
        formStateStore.dispatch(updateStateInRedux({name:"iformClientLoaded",value: true}));
      }
      const unloaded_app= await window.unmountPreviewManual(containerId);
      console.log(unloaded_app);
    }
    window.formLoaderRan = false;
    if(props.passedData.formMataData_json){
      
      // setTimeout(() => {

        ReactDOM.render(
          <Suspense fallback={<div className="Loading_fallback"> {""}</div>}>
            <App 
              childComp="preview" 
              history={props} 
              data={props.passedData} 
              formMataData={props.passedData.formMataData_json}
              appDesignerCallback={props?.Callback}
              containerId={containerId}
            />
          </Suspense>,
          document.getElementById(containerId)
        );
  
      // }, 2000);
    }
    else{
        ReactDOM.render(
          <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
            <App 
              childComp="preview" 
              history={props} 
              data={props.passedData} 
              formMataData={props.passedData.formMataData_json}
              appDesignerCallback={props?.Callback}
              containerId={containerId}
            />
          </Suspense>,
          document.getElementById(containerId)
        );
    
    }  
};

// window.callOnlyOnce = true;

window.renderPreviewInFrame = (containerId, props) => {

  if(props.ContainerId==="ngform"){
    window.istaskOpen= true;
  }
  else{
    window.istaskOpen= false;
  }
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  window.formLoaderRan = false;
  window.langChange = false; // when lang is present in QueryParam
  formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
  ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
        <App 
          childComp="preview" 
          history={props} 
          data={props.passedData} 
          formMataData={props.passedData.formMataData_json}
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
      </Suspense>,
    document.getElementById(containerId)
  );
};

// Reusable Business Function
window.renderReusableBusinessFunction = (containerId, props) => {
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  window.formLoaderRan = false;
  window.langChange = false; // when lang is present in QueryParam
  formStateStore.dispatch(updateStateInRedux({name:"generalDataCall",value: false}));
  ReactDOM.render(
    <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
      <App 
          childComp="reusableFunction" 
          history={props} 
          data={props.passedData} 
          formMataData={props.passedData.formMataData_json}
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
        />
    </Suspense>,
    document.getElementById(containerId)
  )
}

window.unmountPreview = containerId => {
  if(document.getElementById(containerId)){
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};


window.unmountPreviewManual = (containerId) => {
  if(document.getElementById(containerId)){
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};


window.unmountPreviewInFrame = containerId => {
  if(document.getElementById(containerId)){
    return ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};

//  ************************************** ************************************** **************************************************

// ***********************************  MicroFrontend component implementation for MDM Module **************************************
window.renderApp = (containerId, props) => {
  formStateStore.dispatch(updateContainerInfo({key:containerId}));
  if(document.getElementById(containerId)){

    ReactDOM.render(
      <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
        <App 
          childComp="app" 
          history={props} 
          data={props.passedData} 
          appDesignerCallback={props?.Callback} 
          containerId={containerId}
          />
      </Suspense>,
      document.getElementById(containerId)
    );
  }
};

window.unmountApp = containerId => {
  if(document.getElementById(containerId)){
    ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};

window.postToApp = ({ type, payload}) =>{

  switch(type){
    case "applicationPages":  
  }
}

if ( (window.formBuilder_containerId_mf && !document.getElementById(window.formBuilder_containerId_mf) && document.getElementById('LSMSAppPortal_root_not_mf') ) || window.formBuilder_containerId_mf===undefined ) {
  formStateStore.dispatch(reset({key: "default",formState: {}, resetContainerId: "default"}));
  formStateStore.dispatch(updateContainerInfo({key:"default"}));
     ReactDOM.render(     
      <Suspense fallback={<div className="Loading_fallback">{""}</div>}>
        { !window.location.href.includes("processDesigner") && !window.location.href.includes("afb_subform") && cspResponse()}
        <App childComp="app" containerId={"default"} />
      </Suspense>
        , document.getElementById('LSMSAppPortal_root_not_mf'));
}

// ************************************** ************************************************************************************************************************ //


// ****************************************************************** MICROFRONTE END IMPLEMENTTAION ************************************************************* //

const state=formStateStore.getState();
   let containerId
  if(containerId===undefined){
    containerId="default"
  }
 let nonceValue= state.data.find(json => json.key === containerId)?.noncevalue;


window.MdmDataModel = function (appId , appName){
  var props = {
    "uniqueNumber" : nonceValue,
   "Module": "MDM",
   "Component": "DataModelListViewer",
   "InFrame": false,
   "ContainerId": "dataModel_mf",
   "Renderer":"renderDataModelListViewer",
   "Callback":null,
   "source": "AP",
   "auto_generate_table": true,
   "object_type": "AP",
   "object_id": appId,
   "object_name": appName || "Application Name",
   "default_data_fields": [
      {
        "name": "referencekey",
        "alias": "referencekey",
        "type": 1,
        "key_field": true,
        "id": 1
      }
    ],
    data_types: [1,2,3,4,5,8,9,10],
   "Unmount": "unmountDataModelListViewer"
  }
  if(window && window?.loadMicroFrontend ){
    window.loadMicroFrontend(props);
  }
}

window.openDocumentViewer = function (translation, dir, docClicked, docData, containerId){
  const state=formStateStore.getState();
   let newContainerId
  if(newContainerId===undefined){
    newContainerId="default"
  }
 let nonceValue = state.data.find(json => json.key === containerId)?.noncevalue;

  var doc_viewer_props = {
    "uniqueNumber": nonceValue,
    "t":translation || "",
    "direction":dir,
    "source" :"IFORM",
    "dms_type" : docData.dms_type || "1",
    "isPortal" : docData.isPortal,
    "documentInfoProps": docClicked,
    "SetDocumentDataProps": {
              available_doc_types: docData?.available_doc_types,
              upload_doc_as: docData?.upload_doc_as,
              documents: docData?.documents
            },
    "Component": "DocumentViewer",
    "Module": "WCL",
    "InFrame": false,
    "ContainerId": containerId
  }
      if(window && window?.loadMicroFrontend ){
        window.loadMicroFrontend(doc_viewer_props);
      }
}

window.loadIntegrator = function () {
  const path = `/integration/integration.js?version=${getBuildNo()}`;
  const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
      window.docListIntegratorPresent= true;
    }
    document.head.appendChild(script);
}

var loadSessionPopup_count=0;
window.loadSessionPopup = function (props) {
  if (window && window?.loadMicroFrontend && window.MicroAppsMap && Object.keys(window.MicroAppsMap).length > 0 && document.querySelector(`#${props?.ContainerId}`) ) {
    window.loadMicroFrontend(props);
  }
  else if (loadSessionPopup_count < 5){
    window.setTimeout(()=>{
      loadSessionPopup_count = loadSessionPopup_count + 1;
      window.loadSessionPopup(props);
    },2000);
  }
};

window.loadIntegrator_bam = function () {
  const path = `/integration/integration.js?version=${getBuildNo()}`;
  const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
       window.docListIntegratorPresent= true;
    }
    document.head.appendChild(script);
}

window.docListIntegratorPresent= false;
window.loadDoclistComponent = function (loadDoc, docData) {
  const scriptInt = document.createElement('script')
  scriptInt.type = 'text/javascript'
  scriptInt.src =`/integration/integration.js?version=${getBuildNo()}`;
  scriptInt.id= "loadDoclistIntegration"
  scriptInt.onload= () => {
 }
  document.body.appendChild(scriptInt)  

  return true
}

window.loadDoclist = function (props){
  if(window.renderDocumentListViewer)
    window.renderDocumentListViewer(props.ContainerId,{...props, Renderer: "renderDocumentListViewer",Unmount: "unmountDocumentListViewer"});
  else window?.loadMicroFrontend(props.ContainerId, props);
}

window.loadMicroFrontend_formBuilder = function (props){
  window.loadMicroFrontend(props);
}
window.MdmDataObjectsModel = function (props) {
  if (window && window?.loadMicroFrontend) {
    window.loadMicroFrontend(props);
  }
};

window.SessionHandler = function (props) {
  if (window && window?.loadMicroFrontend) {
    window.loadMicroFrontend(props);
  }
};

swDev();